import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import DynamicModalForm from "../../Components/Modal/DynamicModalForm";
import TodoEditModal from "../../Components/Application/Todo/TodoEditModal";
import { ticketFields } from "../../Components/Application/Tickets/TicketsPage";
import { defaultTaskFields } from "../../Components/Application/Task/ListTask";
import { useQuickAddRegistrar } from "./QuickAddProvider";
import { toast } from "react-toastify";

/**
 * Global yedek modallar: herhangi bir sayfada "+" menüsü tıklandığında
 * ilgili sayfa özel handler yoksa bunlar devreye girer.
 * Sayfa bazlı register sonrası override olacağı için öncelik düşük.
 */
const QuickAddFallbacks = () => {
  const [open, setOpen] = useState({});
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();

  // Yeni takvim modülü feature-scope (CalendarProvider yalnızca takvim
  // route'unda mount). QuickAdd "Add Event" tıklandığında takvim sayfasına
  // yönlendirip ?compose=1 query'i ile compose modal'ını açtırırız.
  const openNewEventModal = () => {
    navigate("/calendar/draggable-calendar/dubai?compose=1");
  };

  const fields = useMemo(() => ({
    task: defaultTaskFields,
    multipleTasks: defaultTaskFields,
    note: [
      { name: "title", label: "Title", type: "text" },
      { name: "desc", label: "Description", type: "textarea" },
      { name: "labels", label: "Labels", type: "multiselect", options: [] },
      { name: "file", label: "File", type: "file" },
    ],
    todo: null, // TodoEditModal kullanıyoruz
    ticket: ticketFields,
  }), []);

  const openModal = (key) => {
    setFormData((prev) => ({ ...prev, [key]: {} }));
    setOpen((prev) => ({ ...prev, [key]: true }));
  };

  const closeModal = (key) => setOpen((prev) => ({ ...prev, [key]: false }));

  const onSave = (key) => (data) => {
    toast.success(`${key} created (quick add)`);
    closeModal(key);
  };

  useQuickAddRegistrar(
    {
      addTask: () => openModal("task"),
      addMultipleTasks: () => openModal("multipleTasks"),
      addEvent: () => openNewEventModal(),
      addNote: () => openModal("note"),
      addTodo: () => openModal("todo"),
      addTicket: () => openModal("ticket"),
    },
    // Setter'lar functional update kullanıyor + navigate stable → mount'ta tek
    // sefer register yeter; aksi hâlde her render'da yeni openModal referansı
    // useEffect'i tetikler → setRegistrations → context value değişir → loop.
    []
  );

  return (
    <>
      <DynamicModalForm
        isOpen={!!open.task}
        toggle={() => closeModal("task")}
        title="Add Task"
        fields={fields.task}
        formData={formData.task || {}}
        onSave={onSave("task")}
      />
      <DynamicModalForm
        isOpen={!!open.multipleTasks}
        toggle={() => closeModal("multipleTasks")}
        title="Add Multiple Tasks"
        fields={fields.multipleTasks}
        formData={formData.multipleTasks || {}}
        onSave={onSave("multipleTasks")}
        mode="multiple"
      />
      <DynamicModalForm
        isOpen={!!open.note}
        toggle={() => closeModal("note")}
        title="Add Note"
        fields={fields.note}
        formData={formData.note || {}}
        onSave={onSave("note")}
      />
      <TodoEditModal
        isOpen={!!open.todo}
        toggle={() => closeModal("todo")}
        todo={formData.todo || {}}
        onSave={(d) => {
          onSave("todo")(d);
        }}
        labelOptions={[]}
      />
      <DynamicModalForm
        isOpen={!!open.ticket}
        toggle={() => closeModal("ticket")}
        title="Add Ticket"
        fields={fields.ticket}
        formData={formData.ticket || {}}
        onSave={onSave("ticket")}
      />
    </>
  );
};

export default QuickAddFallbacks;
